import axios from 'axios';

//https://localhost:44375
const resolveBaseURL = () => {
  try {
    const { hostname } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    return window.location.origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientClubEvents = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientClubEvents.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClientClubEvents.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const resolveClubEventAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL().replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (normalizedPath.startsWith('/api/clubevents/')) {
    return `${base}${normalizedPath}`;
  }

  return `${base}/api/clubevents${normalizedPath}`;
};

export default httpClientClubEvents;


